import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '@/App';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Envelope, ArrowLeft, CheckCircle } from '@phosphor-icons/react';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Veuillez entrer votre adresse email'); return; }
    setIsLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error("Erreur lors de l'envoi. Réessayez.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-zinc-200 p-8" data-testid="forgot-password-container">
          {!sent ? (
            <>
              <button onClick={() => navigate('/login')} className="flex items-center gap-1 text-sm text-zinc-500 hover:text-zinc-900 mb-6">
                <ArrowLeft size={16} />Retour
              </button>
              <h2 className="text-xl font-bold mb-1">Mot de passe oublié</h2>
              <p className="text-sm text-zinc-500 mb-6">Entrez votre adresse email. Vous recevrez un lien de réinitialisation.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label className="label-overline">Email</Label>
                  <div className="relative">
                    <Envelope className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" size={18} />
                    <Input type="email" placeholder="votre@email.com" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 rounded-sm" required data-testid="forgot-email-input" />
                  </div>
                </div>
                <Button type="submit" className="w-full rounded-sm bg-zinc-900 hover:bg-zinc-800" disabled={isLoading} data-testid="forgot-submit-btn">
                  {isLoading ? <span className="spinner" /> : 'Envoyer le lien'}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4" data-testid="forgot-success">
              <CheckCircle size={48} className="mx-auto text-emerald-600 mb-4" />
              <h2 className="text-xl font-bold mb-2">Email envoyé</h2>
              <p className="text-sm text-zinc-500 mb-6">Si un compte existe avec l'adresse <strong>{email}</strong>, vous recevrez un email avec un lien de réinitialisation.</p>
              <Button onClick={() => navigate('/login')} variant="outline" className="rounded-sm">Retour à la connexion</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
